import React from 'react';
import { Placemark } from 'react-yandex-maps';

import warningSuccessIcon from '../../../../assets/images/map/warningSuccess.svg';
import almostFinishedIcon from '../../../../assets/images/map/almostFinished.svg';
import disabledIcon from '../../../../assets/images/map/disabled.svg';
import successIcon from '../../../../assets/images/map/success.svg';

const getIcon = (contexuality) => {
  if (contexuality === 'almostFinished') {
    return almostFinishedIcon;
  }

  if (contexuality === 'success') {
    return successIcon;
  }

  if (contexuality === 'warningSuccess' || contexuality === 'warningActive') {
    return warningSuccessIcon;
  }

  return disabledIcon;
};

const size = [20, 20];
const activeSize = [26, 26];

const YMapPoint = React.memo(({ lat, lng, onClick, contexuality, isActive }) =>
  <Placemark
    geometry={[+lat, +lng]}
    onClick={onClick}
    properties={{
      iconContent: '<div> </div>'
    }}
    options={{
      iconLayout: 'default#imageWithContent',
      iconImageSize: isActive ? activeSize : size,
      iconImageOffset: isActive ? [-13, -13] : [-10, -10],
      iconImageHref: getIcon(contexuality)
    }}
  />
);

export default YMapPoint;



// WEBPACK FOOTER //
// ./src/components/common/YMap/YMapPoint/index.js